<template>
  <div id="app">
    <router-view
      v-wechat-title="$route.meta.networkTitle"
      v-if="isRouterAlive"
    />
  </div>
</template>

<script>
import {log} from "three"
import {mapActions, mapGetters} from "vuex"
import versionInfo from '@/utils/version.js'
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
    }
  },
  computed: {
    ...mapGetters(["userInfo", "watermarkOpacity"]),
  },
  data() {
    return {
      isRouterAlive: true,
    }
  },
  mounted() {
		console.log(
			`%c 分支-中通服印章管理系统%c 当前版本号 v${versionInfo[0].version} %c 开发者云玺 %c`,
			'background:#35495e ; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff',
			'background:#007aff ;padding: 1px; border-radius: 0;  color: #fff; font-weight: bold;',
			'background:#aa00ff ;padding: 1px; border-radius: 0 3px 3px 0;  color: #fff; font-weight: bold;',
			'background:transparent'
		)
  },
  watch: {
    //使用watch 监听$router的变化
    $route(to, from) {
      //如果to索引大于from索引,判断为前进状态,反之则为后退状态
      if (to.meta.index > from.meta.index) {
        console.log(to)
        console.log(from)
      } else {
        //			如果跳转到空白页在跳回来
        if (to.fullPath == "/redirect") {
          setTimeout(() => {
            this.$router.replace({
              //replace跟 router.push 很像，唯一的不同就是，它不会向 history 添加新记录，
              path: from.fullPath,
            })
          }, 200)
        }
      }
			if(to.path.includes('/index')){
					// 添加溯源对象接口
					this.addTraceabilityObject()
			}
    },
  },
  methods: {
    addTraceabilityObject() {
      this.GLOBAL.doPost(
        "/watermark/addTraceabilityObject",
        {
          objectId: (this.userInfo || {}).userId,
          watermarkTypes: 3,
          employeeName: (this.userInfo || {}).userName,
        },
        (result) => {
          console.log("addTraceabilityObject.result", result)
          if (result.success) {
            // 获取水印js脚本
            this.generateJSWM()
          }
        }
      )
    },
    generateJSWM() {
      this.GLOBAL.doPost(
        "/watermark/generateJSWM",
        {
          objectId: (this.userInfo || {}).userId,
          watermarkTypes: 3,
          pcWidth: document.body.clientWidth,
          pcHeight: document.body.clientHeight,
          watermarkOpacity: this.watermarkOpacity,
        },
        (result) => {
          console.log("generateJSWM.result", result)
          if (result.success) {
            let script = document.createElement("script")
            script.type = "text/javascript"
            script.text = result.data.js
            document.getElementsByTagName("head")[0].appendChild(script)
          }
        }
      )
    },
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
  },
}
</script>

<style>
@import "../static/css/animate.css";
* {
  box-sizing: border-box;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* 全局样式 */
/* 图片浏览样式开始 */
.lz-el-image {
  width: 100px;
  height: 100px;
  border-radius: 5px;
  background: #f5f7fa;
  line-height: 100px;
  font-size: 30px;
  text-align: center;
  margin-right: 5px;
}

/* 图片浏览样式结束 */
/* 分页公用样式 */
.lz-el-pagination {
  margin: 20px 0;
  float: right;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/App.vue